import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiLoadingChart,
  EuiLoadingContent,
  EuiPanel,
  EuiSpacer,
} from "@elastic/eui";

/**
 * Shared loading skeletons (DESIGN.md §1 "never render an empty container").
 * OUI 1.19 has no `EuiSkeleton*`; these wrap `EuiLoadingContent` / `EuiLoadingChart`
 * (theme-aware, responsive) into the few shapes the app needs.
 */

/** Skeleton rows for a table that is loading its first page. */
export const TableSkeleton = ({
  rows = 6,
}: {
  rows?: number;
}): JSX.Element => (
  <EuiPanel hasShadow={false} hasBorder paddingSize="m">
    <EuiLoadingContent lines={Math.min(Math.max(rows, 1), 10) as any} />
  </EuiPanel>
);

/** Content skeleton for a form/detail panel loading its initial data. */
export const FormSkeleton = (): JSX.Element => (
  <EuiPanel hasShadow={false} hasBorder paddingSize="l">
    <EuiLoadingContent lines={3} />
    <EuiSpacer size="l" />
    <EuiLoadingContent lines={4} />
    <EuiSpacer size="l" />
    <EuiLoadingContent lines={2} />
  </EuiPanel>
);

/** Centered chart-shaped skeleton for dashboards/charts loading their data. */
export const ChartSkeleton = ({
  height = 200,
}: {
  height?: number;
}): JSX.Element => (
  <EuiFlexGroup
    justifyContent="center"
    alignItems="center"
    style={{ minHeight: height }}
    responsive={false}
  >
    <EuiFlexItem grow={false}>
      <EuiLoadingChart size="xl" mono />
    </EuiFlexItem>
  </EuiFlexGroup>
);
